__turbopack_context__.v({
  "button": "qL35bq_button",
  "container": "qL35bq_container",
});
